import { acceptOnlyValidProducts } from './product-list-normalize-value';
export const productListViewer = {
    normalizeLoadedValue: acceptOnlyValidProducts
};

//# sourceMappingURL=definition-viewer.js.map